import { createContext, useContext, useEffect, useState } from "react";
import fr from "./fr";
import en from "./en";
import es from "./es";
import { trackEvent } from "../components/site/track";

const dicts = { fr, en, es };
export const SUPPORTED_LANGS = ["fr", "en", "es"];
export const STORAGE_KEY = "consultants_succes_language";

const detectLang = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && dicts[saved]) return saved;
  } catch (e) { /* storage unavailable */ }
  const nav = (navigator.language || "fr").toLowerCase();
  if (nav.startsWith("en")) return "en";
  if (nav.startsWith("es")) return "es";
  return "fr";
};

const lookup = (obj, path) =>
  path.split(".").reduce((o, k) => (o !== undefined && o !== null ? o[k] : undefined), obj);

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang);

  useEffect(() => {
    document.documentElement.lang = lang;
    const ogT = document.querySelector('meta[property="og:title"]');
    if (ogT && lang !== "fr") ogT.setAttribute("content", lookup(dicts[lang], "seo.title"));
    const ogD = document.querySelector('meta[property="og:description"]');
    if (ogD && lang !== "fr") ogD.setAttribute("content", lookup(dicts[lang], "seo.description"));
  }, [lang]);

  const setLang = (l) => {
    if (!dicts[l] || l === lang) return;
    try { localStorage.setItem(STORAGE_KEY, l); } catch (e) { /* storage unavailable */ }
    window.__vytali_cs_lang = l;
    setLangState(l);
    trackEvent("language_selected", { language: l });
  };

  const t = (key) => {
    const v = lookup(dicts[lang], key);
    if (v !== undefined) return v;
    const fb = lookup(dicts.fr, key);
    return fb !== undefined ? fb : key;
  };

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
